// libs/auth/src/lib/auth-config.token.ts
import { InjectionToken } from '@angular/core';
import { AuthConfig } from '../models/auth-config.model';

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('auth.config');
